function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useRef, useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Icon } from '@keen.io/icons';
import { colors } from '@keen.io/colors';
import { Tooltip } from '@keen.io/ui-core';
import { Container, TooltipContainer } from './Hint.styles';
import { ARROW_DIRECTION } from './contants';

var Hint = function Hint(_ref) {
  var type = _ref.type,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'top' : _ref$position,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? colors.white['500'] : _ref$fill,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 15 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 15 : _ref$width,
      _ref$opacity = _ref.opacity,
      opacity = _ref$opacity === void 0 ? 1 : _ref$opacity,
      message = _ref.message;
  var tooltipRef = useRef(null);

  var _useState = useState({
    visible: false,
    tooltipWidth: 0,
    tooltipHeight: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var visible = state.visible,
      tooltipWidth = state.tooltipWidth,
      tooltipHeight = state.tooltipHeight;
  var tooltipMotion = {
    transition: {
      duration: 0.3
    },
    exit: {
      opacity: 0
    }
  };
  useEffect(function () {
    visible && setState(function (state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        tooltipWidth: tooltipRef.current.clientWidth,
        tooltipHeight: tooltipRef.current.clientHeight
      });
    });
  }, [tooltipRef, visible]);
  return React.createElement(Container, {
    onMouseEnter: function onMouseEnter() {
      return setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          visible: true
        });
      });
    },
    onMouseLeave: function onMouseLeave() {
      return setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          visible: false
        });
      });
    }
  }, React.createElement(AnimatePresence, null, visible && React.createElement(TooltipContainer, Object.assign({
    ref: tooltipRef,
    position: position,
    height: height,
    width: width,
    tooltipWidth: tooltipWidth,
    tooltipHeight: tooltipHeight
  }, tooltipMotion, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    }
  }), React.createElement(Tooltip, {
    mode: "dark",
    hasArrow: true,
    arrowDirection: ARROW_DIRECTION[position]
  }, message))), React.createElement(Icon, {
    type: type,
    fill: fill,
    height: height,
    width: width,
    opacity: opacity
  }));
};

export default Hint;